import { EntidadeBase } from 'hay-core-react';
class PesquisaRespostaModel extends EntidadeBase {
    constructor() {
        super('pesquisaresposta');
    }
}
const instance = new PesquisaRespostaModel();
export default instance;
